import React from 'react'

import Container from 'components/Container/Container'

import HomeSearchForm from './HomeSearchForm'

import Banner from 'assets/images/banner.jpg'
import ColumbiaStartupLab from 'assets/images/columbia_startup_lab.png'
import Almaworks from 'assets/images/almaworks.png'

import {
  HomeSearchSection,
  HomeSearchTItle,
  HomeSearchPartners,
  HomeSearchPartner,
} from './HomeSearch.styled'

const HomeSearch = () => {
  return (
    <HomeSearchSection backgroundImage={Banner}>
      <Container size="medium">
        <HomeSearchTItle
          color="accent"
          preset="huge"
          weight="bold"
          align="center">
          Tennis on your <br />
          schedule
        </HomeSearchTItle>
        <HomeSearchForm />
        <HomeSearchPartners>
          <HomeSearchPartner
            src={ColumbiaStartupLab}
            alt="Columbia Startup Lab"
          />
          <HomeSearchPartner src={Almaworks} alt="Almaworks" />
        </HomeSearchPartners>
      </Container>
    </HomeSearchSection>
  )
}

export default HomeSearch
